
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import BASE_URL from "../../BASEURL";

export default function ClientsCMS() {
  const navigate = useNavigate();
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchClients = async () => {
      setLoading(true);
      setError("");
      try {
        const res = await fetch(`${BASE_URL}/api/client`);
        if (!res.ok) throw new Error("Failed to fetch clients");
        const json = await res.json();
        setClients(Array.isArray(json.data) ? json.data : []);
      } catch (err) {
        setError(err.message || "Failed to fetch clients");
      } finally {
        setLoading(false);
      }
    };
    fetchClients();
  }, []);

  if (loading) return <p className="p-10">Loading...</p>;
  if (error) return <p className="p-10 text-red-500">{error}</p>;

  return (
    <div className="max-w-7xl mx-auto md:p-6">
      {/* HEADER */}
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold text-primaryDark">Our Clients</h1>
        <button
          onClick={() => navigate("/admin/addclient")}
          className="bg-primary text-white px-6 py-2 rounded hover:bg-primaryDark"
        >
          + Add Client
        </button>
      </div>

      {/* CLIENT GRID */}
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-6">
        {clients.length === 0 && <p className="p-10">No clients found.</p>}
        {clients.map((client) => (
          <div
            key={client.id || client._id || client.name}
            className="bg-white p-4 rounded-xl shadow hover:shadow-md hover:shadow-primary transition text-center"
          >
            <img
              src={client.logo}
              alt={client.name}
              className="h-20 mx-auto object-contain"
            />
            <p className="mt-3 font-semibold">{client.name}</p>
            <div className="flex justify-center gap-3 mt-3">
              <button className="text-sm px-4 py-1 border border-red-500 text-red-600 hover:text-white transition hover:bg-red-500 rounded">
                Delete
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
